// Service del listado "Presentes" del monitoreo de asistencia.
// GET /attendance/monitoring/present con los filtros del monitoreo más paginación/búsqueda/orden.

import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import { buildQueryString } from '@/api/shared';
import type {
  LC_ListMonitoringPresentIn,
  LC_ListMonitoringPresentOut,
} from '../types/monitoringPresent.types';


export class MonitoringPresentService {
  async get(
    params: LC_ListMonitoringPresentIn,
    signal?: AbortSignal,
  ): Promise<ApiResponse<LC_ListMonitoringPresentOut>> {
    const query = buildQueryString({ ...params });
    const endpoint = `${API_CONFIG.ENDPOINTS.MONITORING_PRESENT}${query}`;

    return apiClient.get<LC_ListMonitoringPresentOut>(endpoint, { signal });
  }
}

export const monitoringPresentService = new MonitoringPresentService();
